(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["swopper-promotion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ho-swopper-promo')) {
    customElements.define('ho-swopper-promo', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        this.refresh();
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      refresh() {
        window.clearTimeout(this.timer);

        const end = Date.parse(this.dataset.endsAt || '');
        const remaining = end - Date.now();
        const active = this.dataset.enabled === 'true'
          && Number.isFinite(end)
          && remaining > 0;

        this.dataset.active = String(active);
        this.querySelectorAll('[data-swopper-promotion]').forEach((element) => {
          element.hidden = !active;
        });

        if (active) {
          this.timer = window.setTimeout(
            this.refresh,
            Math.min(remaining + 50, 60000)
          );
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
